






























import { TupleType } from 'expangine-runtime';
import { TupleSubs } from './TupleTypes';
import { TupleGridOptions } from './TupleGridTypes';
import TupleGridField from './TupleGridField.vue';
import TypeInputBase from '../TypeInputBase';


export default TypeInputBase<TupleType, TupleGridOptions, any[], TupleSubs>(Array).extend({
  name: 'TupleGrid',
  components: {
    TupleGridField,
  },
});
